import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faReceipt } from '@fortawesome/free-solid-svg-icons'
import FuncionarioService from '../../../services/funcionarios';
import '../../../styles/diario.scss';


function HomeLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const [mes, setMes] = useState("");
    const [holerite, setHolerite] = useState("");
    const [esconde, setEsconde] = useState('card-list nao-mostra');
    const nome = localStorage.getItem('nome');
    const func = JSON.parse(localStorage.getItem('funcionario'))

    const handleDownload = async () => {
        try {
            var funcId = func._id
            const response = await FuncionarioService.downloadHolerite(funcId, holerite._id);
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
        } catch (err) {
            alert("Erro ao baixar holerite");
        }
    };

    useEffect(() => {
        if (func.holerite.length >= 1) {
            const ultima = func.holerite[func.holerite.length - 1];
            setMes(ultima.mes);
            setHolerite(ultima);
            setEsconde('card-list');
        }
    }, []);

    const nomeMes = [
        "",            // índice 0 (não usado)
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
        "13º Salário - 1ª Parcela",
        "13º Salário - 2ª Parcela",
        "Informe Anual de Rendimentos"
    ];

    if (direct) {
        return <Navigate to={direct} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vindo(a), {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card className={esconde} onClick={handleDownload}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faReceipt} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Consultar Holerite Mês atual ({nomeMes[mes]})</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/funcionarios/holerites')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faList} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Consultar Holerites Anteriores</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default HomeLoggedScreen;